import { createSlice } from "@reduxjs/toolkit";

const trackhrdataslice = createSlice({
  name: "trackhrdata",
  initialState: {
    apipathurl: "",
    colors: {},
    internalurl:"",
    loading: false
  },
  reducers: {
    setTrackHRData: (state, action) => {
      state.apipathurl = action.payload.apipathurl;
      state.colors = action.payload.colors;
      state.internalurl=action.payload.internalurl;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    }
  }
});

export const { setTrackHRData, setLoading } = trackhrdataslice.actions;
export default trackhrdataslice.reducer;
